import { userConstants } from "../_constants";
import { userService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";

export const userActions = {
  login,
  logout,
  register,
  registerDemoClient,
  getAllUsers,
  getAllUsersForImpersonation,
  getUserTopCardInfo,
  editUserDetailsByAdmin,
  getUserProfile,
  resetPassword,
  verifyToken,
  verifyDefaultToken,
  createPassword,
  changePassword,
  delete: _delete,
  updateProfile,
  getAllCardsForUser,
  updatePassword,
  getAllNotifications,
  getAccessControl,
  getAccessControlForUser,
  postAccessControlForUser,
  getAccessControlForUserByToken,
  getUserFilters,
  applyUserFilter,
  getSessionInfo,
  onboardRequest,
  retrieveCustomerDetails,
  applyFilterNofitications,
  getNotificationCount,
  checkDuplicateUserName,
  updateNotification,
  DuplicateUserNameForDemo,
  fetchAllLoginDetailsForUser,
  logutUserByTokenId,
  fetchAllLoginDetails,
  // closeAccount,
  verfiyUserSubscription,
  resendUserVerification,
  loginAsUserImpersona,
  createMPin,
  shareSecureResourceUrlByEmail,
  shareSecurAssetByEmail,
  userSessionTopCards,
  getAllUserSessionFilters,
  applyUserSessionFilters,
  managedAInotification,
  getAllActiveUsers,
  updateIsNewNotificationId,
  getNotification,
  searchNotification,
  applyNotification,
  fetchNotificationOptions,
  signup,
  checkDomainAvailability,
  generateEmailOTP,
  verifyEmailOTP,
  resendEmailOTP,
};

function shareSecurAssetByEmail(formData) {
  return (dispatch) => {
    dispatch(request());
    userService.shareSecurAssetByEmail(formData).then(
      (data) => {
        dispatch(success(data.message));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.SHARE_OVER_EMAIL_REQUEST };
  }
  function success(data) {
    return {
      type: userConstants.SHARE_OVER_EMAIL_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: userConstants.SHARE_OVER_EMAIL_FAILURE,
      error,
    };
  }
}

function shareSecureResourceUrlByEmail(formData) {
  return (dispatch) => {
    dispatch(request());
    userService.shareSecureResourceUrlByEmail(formData).then(
      (data) => {
        dispatch(success(data.message));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.SHARE_OVER_EMAIL_REQUEST };
  }
  function success(data) {
    return {
      type: userConstants.SHARE_OVER_EMAIL_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: userConstants.SHARE_OVER_EMAIL_FAILURE,
      error,
    };
  }
}

function getUserFilters() {
  return (dispatch) => {
    dispatch(request());
    userService.getUserFilters().then(
      (filtersUser) => dispatch(success(filtersUser)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return {
      type: userConstants.USER_FETCH_FILTER_REQUEST,
    };
  }
  function success(filtersUser) {
    return {
      type: userConstants.USER_FETCH_FILTER_SUCCESS,
      filtersUser,
    };
  }
  function failure(error) {
    return {
      type: userConstants.USER_FETCH_FILTER_FAILURE,
      error,
    };
  }
}

function getAllNotifications(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    userService.getAllNotifications(offset, limit).then(
      (notifications) => dispatch(success(notifications)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_REQUEST };
  }
  function success(notifications) {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_SUCCESS, notifications };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_FAILURE, error };
  }
}
// update notification
function updateNotification(userId) {
  return (dispatch) => {
    dispatch(request());
    userService.updateNotification(userId).then(
      (notifications) => dispatch(success(notifications)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.UPDATE_ALL_NOTIFICATIONS_REQUEST };
  }
  function success(notifications) {
    return {
      type: userConstants.UPDATE_ALL_NOTIFICATIONS_SUCCESS,
      notifications,
    };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_ALL_NOTIFICATIONS_FAILURE, error };
  }
}
function getNotificationCount() {
  return (dispatch) => {
    dispatch(request());
    userService.getNotificationCount().then(
      (notificationCount) => dispatch(success(notificationCount)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_NOTIFICATION_COUNT_REQUEST };
  }
  function success(notificationCount) {
    return {
      type: userConstants.GET_NOTIFICATION_COUNT_SUCCESS,
      notificationCount,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_NOTIFICATION_COUNT_FAILURE, error };
  }
}
function updatePassword(oldPassword, newPassword) {
  return (dispatch) => {
    dispatch(request());
    userService.updatePassword(oldPassword, newPassword).then(
      (user) => {
        dispatch(success(user));
        dispatch(alertActions.success("Password Updated SuccessFully"));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.PASSWORD_UPDATE_REQUEST };
  }
  function success(user) {
    return { type: userConstants.PASSWORD_UPDATE_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.PASSWORD_UPDATE_FAILURE, error };
  }
}

function updateProfile(formData, timeZone) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  user.timeZone = timeZone;

  return (dispatch) => {
    dispatch(request());
    userService.updateProfile(formData).then(
      (data) => {
        localStorage.setItem("user", JSON.stringify(user));
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.UPDATE_PROFILE_REQUEST };
  }
  function success(data) {
    return { type: userConstants.UPDATE_PROFILE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_PROFILE_FAILURE, error };
  }
}

function getAllCardsForUser(userId, roleId) {
  return (dispatch) => {
    dispatch(request());
    userService.getAllCardsForUser(userId, roleId).then(
      (cardDetails) => {
        dispatch(success(cardDetails));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.GET_ALL_CARDS_REQUEST };
  }
  function success(cardDetails) {
    return { type: userConstants.GET_ALL_CARDS_SUCCESS, cardDetails };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_CARDS_FAILURE, error };
  }
}

function verifyDefaultToken(token) {
  return (dispatch) => {
    dispatch(request({ token }));
    userService.verifyDefaultToken(token).then(
      (email) => {
        dispatch(success(email));
        dispatch(alertActions.success(email.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(email) {
    return { type: userConstants.VERIFY_DEFAULT_TOKEN_REQUEST, email };
  }
  function success(email) {
    return { type: userConstants.VERIFY_DEFAULT_TOKEN_SUCCESS, email };
  }
  function failure(error) {
    return { type: userConstants.VERIFY_DEFAULT_TOKEN_FAILURE, error };
  }
}

function createPassword(defaultPasswordToken, oldPassword, newPassword) {
  return (dispatch) => {
    dispatch(request());

    userService
      .createPassword(defaultPasswordToken, oldPassword, newPassword)
      .then(
        (user) => {
          dispatch(success(user));
          dispatch(alertActions.success(user.message));
          setTimeout(() => {
            history.push("/auth/signin");
          }, 5000);
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
          if (error.includes("The Temporary Password doesn't match")) {
            setTimeout(() => {
              history.push("/auth/signin");
            }, 5000);
          }
        }
      );
  };

  function request(email) {
    return { type: userConstants.PASSWORD_CREATE_REQUEST, email };
  }
  function success(email) {
    return { type: userConstants.PASSWORD_CREATE_SUCCESS, email };
  }
  function failure(error) {
    return { type: userConstants.PASSWORD_CREATE_FAILURE, error };
  }
}

function verifyToken(resetPasswordToken) {
  return (dispatch) => {
    dispatch(request({ resetPasswordToken }));
    userService.verifyToken(resetPasswordToken).then(
      (email) => {
        dispatch(success(email));
        dispatch(alertActions.success(email.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(email) {
    return { type: userConstants.VERIFY_TOKEN_REQUEST, email };
  }
  function success(email) {
    return { type: userConstants.VERIFY_TOKEN_SUCCESS, email };
  }
  function failure(error) {
    return { type: userConstants.VERIFY_TOKEN_FAILURE, error };
  }
}

function changePassword(emailId, newPassword, clientId) {
  return (dispatch) => {
    dispatch(request({ emailId, newPassword, clientId }));
    userService.changePassword(emailId, newPassword, clientId).then(
      (user) => {
        dispatch(success(user));
        dispatch(alertActions.success(user.message));
        setTimeout(() => {
          history.push("/auth/signin");
        }, 5000);
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(email) {
    return { type: userConstants.PASSWORD_CHANGE_REQUEST, email };
  }
  function success(email) {
    return { type: userConstants.PASSWORD_CHANGE_SUCCESS, email };
  }
  function failure(error) {
    return { type: userConstants.PASSWORD_CHANGE_FAILURE, error };
  }
}

function resetPassword(emailId, companyHostname) {
  return (dispatch) => {
    dispatch(request({ emailId, companyHostname }));
    userService.resetPassword(emailId, companyHostname).then(
      (email) => {
        dispatch(success(email));
        dispatch(alertActions.success(email.message));
        setTimeout(() => {
          history.push("/auth/signin");
        }, 3000);
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(email) {
    return { type: userConstants.PASSWORD_RESET_REQUEST, email };
  }
  function success(email) {
    return { type: userConstants.PASSWORD_RESET_SUCCESS, email };
  }
  function failure(error) {
    return { type: userConstants.PASSWORD_RESET_FAILURE, error };
  }
}

function login(email, password, companyHostname) {
  return (dispatch) => {
    dispatch(request({ email }));

    userService.login(email, password, companyHostname).then(
      (user) => {
        if (user.requireOTP === true) {
          history.push("/auth/verify-otp");
          dispatch(success(user));
        } else if (user.setupOTP === true) {
          history.push("/auth/register-2fa");
          dispatch(success(user));
        } else if (user.auth === true && user.requireOTP === false) {
          //redirect to the allocated asset page
          var redirectUrl = null;
          if (
            user.navItems.userNavItemJson &&
            user.navItems.userNavItemJson.items[0]
          ) {
            redirectUrl =
              user.navItems.userNavItemJson.items[0].children[0].url ||
              user.navItems.userNavItemJson.items[0].children[0].children[0]
                .url;
            history.push(redirectUrl);
          }

          dispatch(success(user));
        } else {
          history.push("/auth/signin");
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function register(formData) {
  return (dispatch) => {
    dispatch(request());
    userService.register(formData).then(
      (newUser) => {
        dispatch(success(newUser));
        dispatch(alertActions.success(newUser.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.REGISTER_REQUEST };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function DuplicateUserNameForDemo(userName) {
  return (dispatch) => {
    dispatch(request());
    userService.DuplicateUserNameForDemo(userName).then(
      (newUser) => {
        dispatch(success(newUser));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.CHECK_DUPLICATE_USERNAME_REQUEST };
  }
  function success(newUser) {
    return { type: userConstants.CHECK_DUPLICATE_USERNAME_SUCCESS, newUser };
  }
  function failure(error) {
    return { type: userConstants.CHECK_DUPLICATE_USERNAME_FAILURE, error };
  }
}

function registerDemoClient(formData) {
  return (dispatch) => {
    dispatch(request(formData));
    userService.registerDemoClient(formData).then(
      (newUser) => {
        dispatch(success(newUser));
        dispatch(alertActions.success(newUser.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}
function getAllUsers(offset, limit) {
  return (dispatch) => {
    dispatch(request());

    userService.getAllUsers(offset, limit).then(
      (users) => dispatch(success(users)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

function getAllUsersForImpersonation() {
  return (dispatch) => {
    dispatch(request());
    userService.getAllUsersForImpersonation().then(
      (usersForImpersonation) => dispatch(success(usersForImpersonation)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_ALL_USERS_IMPERSONATION_REQUEST };
  }
  function success(usersForImpersonation) {
    return {
      type: userConstants.GET_ALL_USERS_IMPERSONATION_SUCCESS,
      usersForImpersonation,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_USERS_IMPERSONATION_FAILURE, error };
  }
}

function getUserTopCardInfo() {
  return (dispatch) => {
    dispatch(request());

    userService.getUserTopCardInfo().then(
      (userTopCards) => dispatch(success(userTopCards)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_USER_TOP_CARD_INFO_REQUEST };
  }
  function success(userTopCards) {
    return { type: userConstants.GET_USER_TOP_CARD_INFO_SUCCESS, userTopCards };
  }
  function failure(error) {
    return { type: userConstants.GET_USER_TOP_CARD_INFO_FAILURE, error };
  }
}

function editUserDetailsByAdmin(formData, userId) {
  return (dispatch) => {
    dispatch(request());
    userService.editUserDetailsByAdmin(formData, userId).then(
      (userEdited) => {
        dispatch(success(userEdited));
        dispatch(alertActions.success(userEdited.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.UPDATE_USER_DETAILS_REQUEST };
  }
  function success(userEdited) {
    return { type: userConstants.UPDATE_USER_DETAILS_SUCCESS, userEdited };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_USER_DETAILS_FAILURE, error };
  }
}

function getUserProfile() {
  return (dispatch) => {
    dispatch(request());

    userService.getUserProfile().then(
      (user) => dispatch(success(user)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GETUSER_REQUEST };
  }
  function success(user) {
    return { type: userConstants.GETUSER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.GETUSER_FAILURE, error };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(itemId) {
  return (dispatch) => {
    dispatch(request(itemId));

    userService.delete(itemId).then(
      (user) => dispatch(success(itemId)),
      (error) => dispatch(failure(itemId, error.toString()))
    );
  };

  function request(id) {
    return { type: userConstants.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userConstants.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userConstants.DELETE_FAILURE, id, error };
  }
}

function getAccessControl() {
  return (dispatch) => {
    dispatch(request());

    userService.getAccessControl().then(
      (allPolicies) => dispatch(success(allPolicies)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_ALL_ACCESS_CONTROL_REQUEST };
  }
  function success(allPolicies) {
    return { type: userConstants.GET_ALL_ACCESS_CONTROL_SUCCESS, allPolicies };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_ACCESS_CONTROL_FAILURE, error };
  }
}

function getAccessControlForUser(userId) {
  return (dispatch) => {
    dispatch(request());

    userService.getAccessControlForUser(userId).then(
      (policiesForUser) => dispatch(success(policiesForUser)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_USERS_ACCESS_CONTROL_REQUEST };
  }
  function success(policiesForUser) {
    return {
      type: userConstants.GET_USERS_ACCESS_CONTROL_SUCCESS,
      policiesForUser,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_USERS_ACCESS_CONTROL_FAILURE, error };
  }
}

function postAccessControlForUser(formData, userId) {
  return (dispatch) => {
    dispatch(request());

    userService.postAccessControlForUser(formData, userId).then(
      (postPolicies) => dispatch(success(postPolicies)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.POST_USERS_ACCESS_CONTROL_REQUEST };
  }
  function success(postPolicies) {
    return {
      type: userConstants.POST_USERS_ACCESS_CONTROL_SUCCESS,
      postPolicies,
    };
  }
  function failure(error) {
    return { type: userConstants.POST_USERS_ACCESS_CONTROL_FAILURE, error };
  }
}

function getAccessControlForUserByToken() {
  return (dispatch) => {
    dispatch(request());

    userService.getAccessControlForUserByToken().then(
      (policiesForUser) => dispatch(success(policiesForUser)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.USERS_ACCESS_CONTROL_REQUEST };
  }
  function success(policiesForUser) {
    return {
      type: userConstants.USERS_ACCESS_CONTROL_SUCCESS,
      policiesForUser,
    };
  }
  function failure(error) {
    return { type: userConstants.USERS_ACCESS_CONTROL_FAILURE, error };
  }
}

function applyUserFilter(
  role,
  status,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  return (dispatch) => {
    dispatch(request());
    userService
      .applyUserFilter(role, status, startDate, endDate, search, offset, limit)
      .then(
        (users) => dispatch(success(users)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return {
      type: userConstants.GETALL_SUCCESS,
      users,
    };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

function getSessionInfo(sessionId) {
  return (dispatch) => {
    dispatch(request());
    userService.getSessionInfo(sessionId).then(
      (sessionInfo) => dispatch(success(sessionInfo)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_SESSION_INFO_REQUEST };
  }
  function success(sessionInfo) {
    return {
      type: userConstants.GET_SESSION_INFO_SUCCESS,
      sessionInfo,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_SESSION_INFO_FAILURE, error };
  }
}

function onboardRequest(formData) {
  return (dispatch) => {
    dispatch(request());
    userService.onboardRequest(formData).then(
      (onboarded) => {
        dispatch(success(onboarded));
        dispatch(alertActions.success("ProbytoAI Onboarding successfull."));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.ONBOARD_USER_REQUEST };
  }
  function success(onboarded) {
    return { type: userConstants.ONBOARD_USER_SUCCESS, onboarded };
  }
  function failure(error) {
    return { type: userConstants.ONBOARD_USER_FAILURE, error };
  }
}
//retrieveCustomerDetails
function retrieveCustomerDetails(customerId) {
  return (dispatch) => {
    dispatch(request());
    userService.retrieveCustomerDetails(customerId).then(
      (customerDetails) => dispatch(success(customerDetails)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_CUSTOMER_DETAILS_REQUEST };
  }
  function success(customerDetails) {
    return {
      type: userConstants.GET_CUSTOMER_DETAILS_SUCCESS,
      customerDetails,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_CUSTOMER_DETAILS_FAILURE, error };
  }
}
//applyFilterNofitications
function applyFilterNofitications(
  usecaseName,
  status,
  user,
  type,
  startDate,
  endDate,
  search,
  limit,
  offset
) {
  return (dispatch) => {
    dispatch(request());
    userService
      .applyFilterNofitications(
        usecaseName,
        status,
        user,
        type,
        startDate,
        endDate,
        search,
        limit,
        offset
      )
      .then(
        (notifications) => {
          dispatch(success(notifications));
        },
        (error) => {
          dispatch(failure(error.toString));
        }
      );
  };
  function request() {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_REQUEST };
  }
  function success(notifications) {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_SUCCESS, notifications };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_FAILURE, error };
  }
}

//checkDuplicateUserName
function checkDuplicateUserName(userName) {
  return (dispatch) => {
    dispatch(request());
    userService.checkDuplicateUserName(userName).then(
      (newUser) => dispatch(success(newUser)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.CHECK_DUPLICATE_USERNAME_REQUEST };
  }
  function success(newUser) {
    return { type: userConstants.CHECK_DUPLICATE_USERNAME_SUCCESS, newUser };
  }
  function failure(error) {
    return { type: userConstants.CHECK_DUPLICATE_USERNAME_FAILURE, error };
  }
}

function fetchAllLoginDetails(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    userService.fetchAllLoginDetails(offset, limit).then(
      (loginDetails) => dispatch(success(loginDetails)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_REQUEST };
  }
  function success(loginDetails) {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_SUCCESS, loginDetails };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_FAILURE, error };
  }
}

function userSessionTopCards() {
  return (dispatch) => {
    dispatch(request());
    userService.userSessionTopCards().then(
      (loginDetailsTopCards) => dispatch(success(loginDetailsTopCards)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_TOP_CARDS_REQUEST };
  }
  function success(loginDetailsTopCards) {
    return {
      type: userConstants.GET_ALL_LOGIN_DETAILS_TOP_CARDS_SUCCESS,
      loginDetailsTopCards,
    };
  }
  function failure(error) {
    return {
      type: userConstants.GET_ALL_LOGIN_DETAILS_TOP_CARDS_FAILURE,
      error,
    };
  }
}

function applyUserSessionFilters(formData, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    userService.applyUserSessionFilters(formData, offset, limit).then(
      (loginDetails) => dispatch(success(loginDetails)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_REQUEST };
  }
  function success(loginDetails) {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_SUCCESS, loginDetails };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_FAILURE, error };
  }
}

function getAllUserSessionFilters() {
  return (dispatch) => {
    dispatch(request());
    userService.getAllUserSessionFilters().then(
      (userSessionFilters) => dispatch(success(userSessionFilters)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_ALL_USER_SESSION_FILTERS_REQUEST };
  }
  function success(userSessionFilters) {
    return {
      type: userConstants.GET_ALL_USER_SESSION_FILTERS_SUCCESS,
      userSessionFilters,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_USER_SESSION_FILTERS_FAILURE, error };
  }
}

function fetchAllLoginDetailsForUser(userId) {
  return (dispatch) => {
    dispatch(request());
    userService.fetchAllLoginDetailsForUser(userId).then(
      (loginDetails) => dispatch(success(loginDetails)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_REQUEST };
  }
  function success(loginDetails) {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_SUCCESS, loginDetails };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_LOGIN_DETAILS_FAILURE, error };
  }
}
function logutUserByTokenId(tokenIds) {
  return (dispatch) => {
    dispatch(request());
    userService.logutUserByTokenId(tokenIds).then(
      (userLogout) => dispatch(success(userLogout)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: userConstants.USER_LOGOUT_BY_TOKEN_REQUEST };
  }
  function success(userLogout) {
    return { type: userConstants.USER_LOGOUT_BY_TOKEN_SUCCESS, userLogout };
  }
  function failure(error) {
    return { type: userConstants.USER_LOGOUT_BY_TOKEN_FAILURE, error };
  }
}

function verfiyUserSubscription(token) {
  return (dispatch) => {
    dispatch(request());
    userService.verfiyUserSubscription(token).then(
      (verifiedSub) => {
        dispatch(success(verifiedSub));
        dispatch(alertActions.success(verifiedSub.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.VERIFY_SUBSCRIPTION_REQUEST };
  }
  function success(verifiedSub) {
    return { type: userConstants.VERIFY_SUBSCRIPTION_SUCCESS, verifiedSub };
  }
  function failure(error) {
    return { type: userConstants.VERIFY_SUBSCRIPTION_FAILURE, error };
  }
}
//Login as impersonate user
function loginAsUserImpersona(userId) {
  return (dispatch) => {
    dispatch(request());
    userService.loginAsUserImpersona(userId).then(
      (impersonaUser) => {
        if (impersonaUser.auth && !impersonaUser.requireOTP) {
          var redirectUrl = null;
          if (
            impersonaUser.navItems.userNavItemJson &&
            impersonaUser.navItems.userNavItemJson.items[0]
          ) {
            redirectUrl =
              impersonaUser.navItems.userNavItemJson.items[0].children[0].url ||
              impersonaUser.navItems.userNavItemJson.items[0].children[0]
                .children[0].url;
          }
          window.location.reload();
          history.push(redirectUrl);
          dispatch(success(impersonaUser));
        } else {
          history.push("/auth/signin");
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.USER_IMPERSONATE_REQUEST };
  }
  function success(impersonaUser) {
    return { type: userConstants.USER_IMPERSONATE_SUCCESS, impersonaUser };
  }
  function failure(error) {
    return { type: userConstants.USER_IMPERSONATE_FAILURE, error };
  }
}
//resend user activation email
function resendUserVerification(email, companyHostname) {
  return (dispatch) => {
    dispatch(request());
    userService.resendUserVerification(email, companyHostname).then(
      (resendToken) => {
        dispatch(success(resendToken));
        dispatch(alertActions.success(resendToken.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.RESEND_VERIFY_REQUEST };
  }
  function success(resendToken) {
    return { type: userConstants.RESEND_VERIFY_SUCCESS, resendToken };
  }
  function failure(error) {
    return { type: userConstants.RESEND_VERIFY_FAILURE, error };
  }
}
function createMPin(mpin, userId) {
  return (dispatch) => {
    dispatch(request());
    userService.createMPin(mpin, userId).then(
      (mpin) => {
        dispatch(success(mpin));
        dispatch(alertActions.success(mpin.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.CREATE_MPIN_REQUEST };
  }
  function success(mpin) {
    return { type: userConstants.CREATE_MPIN_SUCCESS, mpin };
  }
  function failure(error) {
    return { type: userConstants.CREATE_MPIN_FAILURE, error };
  }
}

function managedAInotification(aiNotification) {
  return (dispatch) => {
    dispatch(request());
    userService.managedAInotification(aiNotification).then(
      (aiNotification) => {
        dispatch(success(aiNotification));
        dispatch(alertActions.success(aiNotification.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.AINOTIFICATION_UPDATE_REQUEST };
  }
  function success(aiNotification) {
    return {
      type: userConstants.AINOTIFICATION_UPDATE_SUCCESS,
      aiNotification,
    };
  }
  function failure(error) {
    return { type: userConstants.AINOTIFICATION_UPDATE_FAILURE, error };
  }
}

function getAllActiveUsers() {
  return (dispatch) => {
    dispatch(request());
    userService.getAllActiveUsers().then(
      (activeUsers) => dispatch(success(activeUsers)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GET_ALL_ACTIVE_USERS_REQUEST };
  }
  function success(activeUsers) {
    return { type: userConstants.GET_ALL_ACTIVE_USERS_SUCCESS, activeUsers };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_ACTIVE_USERS_FAILURE, error };
  }
}

function updateIsNewNotificationId(notificationId = null) {
  return (dispatch) => {
    dispatch(request());
    userService.updateIsNewNotificationId(notificationId).then(
      (response) => {
        dispatch(success(response));
        dispatch(alertActions.success(response.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.UPDATE_IS_NEW_NOTIFICATION_COUNT_REQUEST };
  }
  function success(response) {
    return {
      type: userConstants.UPDATE_IS_NEW_NOTIFICATION_COUNT_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return {
      type: userConstants.UPDATE_IS_NEW_NOTIFICATION_COUNT_FAILURE,
      error,
    };
  }
}

function getNotification() {
  return (dispatch) => {
    dispatch(request());
    userService.getNotification().then(
      (notification) => {
        dispatch(success(notification));
        dispatch(alertActions.success(notification.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.GET_NOTIFICATION_REQUEST };
  }
  function success(notification) {
    return { type: userConstants.GET_NOTIFICATION_SUCCESS, notification };
  }
  function failure(error) {
    return { type: userConstants.GET_NOTIFICATION_FAILURE, error };
  }
}

function searchNotification(search, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    userService.searchNotification(search, offset, limit).then(
      (notification) => {
        dispatch(success(notification));
        dispatch(alertActions.success(notification.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_REQUEST };
  }
  function success(notifications) {
    return {
      type: userConstants.GET_ALL_NOTIFICATIONS_SUCCESS,
      notifications,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_FAILURE, error };
  }
}

function fetchNotificationOptions() {
  return (dispatch) => {
    dispatch(request());
    userService.fetchNotificationOptions().then(
      (notificationOptions) => {
        dispatch(success(notificationOptions));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.FETCH_NOTIFICATION_OPTIONS_REQUEST };
  }
  function success(notificationOptions) {
    return {
      type: userConstants.FETCH_NOTIFICATION_OPTIONS_SUCCESS,
      notificationOptions,
    };
  }
  function failure(error) {
    return { type: userConstants.FETCH_NOTIFICATION_OPTIONS_FAILURE, error };
  }
}

function applyNotification(
  createdBy,
  status,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  return (dispatch) => {
    dispatch(request());
    userService
      .applyNotification(
        createdBy,
        status,
        startDate,
        endDate,
        search,
        offset,
        limit
      )
      .then(
        (notifications) => {
          dispatch(success(notifications));
        },
        (error) => {
          dispatch(failure(error.toString));
        }
      );
  };
  function request() {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_REQUEST };
  }
  function success(notifications) {
    return {
      type: userConstants.GET_ALL_NOTIFICATIONS_SUCCESS,
      notifications,
    };
  }
  function failure(error) {
    return { type: userConstants.GET_ALL_NOTIFICATIONS_FAILURE, error };
  }
}

function signup(payload) {
  return (dispatch) => {
    dispatch(request());
    userService.signup(payload).then(
      (response) => {
        dispatch(success(response));
        dispatch(alertActions.success("Company registered successfully"));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.REGISTER_COMPANY_REQUEST };
  }
  function success(response) {
    return {
      type: userConstants.REGISTER_COMPANY_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return {
      type: userConstants.REGISTER_COMPANY_FAILURE,
      error,
    };
  }
}

function checkDomainAvailability(data) {
  return (dispatch) => {
    dispatch(request());
    userService.checkDomainAvailability(data).then(
      (response) => {
        dispatch(success(response));
        dispatch(alertActions.success(response.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.CHECK_DOMAIN_AVAILABILITY_REQUEST };
  }
  function success(response) {
    return {
      type: userConstants.CHECK_DOMAIN_AVAILABILITY_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return {
      type: userConstants.CHECK_DOMAIN_AVAILABILITY_FAILURE,
      error,
    };
  }
}

function generateEmailOTP(email, companyId, userId) {
  return (dispatch) => {
    dispatch(request());
    userService.generateEmailOTP(email, companyId, userId).then(
      (response) => {
        dispatch(success(response));
        dispatch(alertActions.success(response.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.GENERATE_EMAIL_OTP_REQUEST };
  }
  function success(response) {
    return {
      type: userConstants.GENERATE_EMAIL_OTP_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return {
      type: userConstants.GENERATE_EMAIL_OTP_FAILURE,
      error,
    };
  }
}

function verifyEmailOTP(email, otp) {
  return (dispatch) => {
    dispatch(request());
    userService.verifyEmailOTP(email, otp).then(
      (response) => {
        dispatch(success(response));
        dispatch(alertActions.success(response.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.VERIFY_EMAIL_OTP_REQUEST };
  }
  function success(response) {
    return {
      type: userConstants.VERIFY_EMAIL_OTP_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return {
      type: userConstants.VERIFY_EMAIL_OTP_FAILURE,
      error,
    };
  }
}

function resendEmailOTP(email, companyId, userId) {
  return (dispatch) => {
    dispatch(request());
    userService.resendEmailOTP(email, companyId, userId).then(
      (response) => {
        dispatch(success(response));
        dispatch(alertActions.success(response.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.RESEND_EMAIL_OTP_REQUEST };
  }
  function success(response) {
    return {
      type: userConstants.RESEND_EMAIL_OTP_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return {
      type: userConstants.RESEND_EMAIL_OTP_FAILURE,
      error,
    };
  }
}
